export default "__VITE_ASSET__413b964a__"